import { render, staticRenderFns } from "./witnesses-form.vue?vue&type=template&id=20e4c313&scoped=true"
import script from "./witnesses-form.vue?vue&type=script&lang=js"
export * from "./witnesses-form.vue?vue&type=script&lang=js"
import style0 from "./witnesses-form.vue?vue&type=style&index=0&id=20e4c313&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e4c313",
  null
  
)

export default component.exports